import { FeatureFlag } from '@golden/gdk-admin'
import TKeyType from '../../i18ns/admin/TKeyType'

const featureFlagName: { [key in FeatureFlag]: TKeyType } = {}

export default featureFlagName
